export default __webpack_public_path__ + "static/FyranSans-Regular-279662df7dc795c19baf0e0b7268e014.woff2";